import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../../store";
import * as httpClient from "../../../../util/httpClient";
import { Notification } from "../../../common/Notification";
import * as MyAccountActions from "../../../../store/myAccount/actions";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../../../util/patterns";
import { CAProvinces, stateList } from "../../../../util/CommonLists";
import { GetCountryListAndInternationalSupport } from "../../../../util/countryListAndInternationalSupport";
import i18nService from "../../../../util/Internationalization/i18n/i18n";
import * as services from "../../../../store/service";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const CompanyAddress = (props: any) => {
    const { t: tLang } = useTranslation();
    const dispatch = useDispatch();
    const businessInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._businessInformation
                : null
            : null
    );
    const getAccountInformation = (forceReload?: boolean) => dispatch(MyAccountActions.actionCreators.getAccountInformation(forceReload));
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const personalAccountInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._personalAccountInformation
                : null
            : null
    );
    const contactPreference = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._contactPreference
                : null
            : null
    );
    const [showEdit, setShowEdit] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const { supportInternational, getCountries } = GetCountryListAndInternationalSupport();
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));

    const setCountry = () => {
        if(!supportInternational && accountInfo!.country ==null){
            accountInfo!.country = "US";
        }
      
    };

    const countryChangeDetected = () => {
        i18nService.setRegionBasedonCountry(watch("country"));
        setZipCode(i18nService.get("ZipCode"));
        setValue("city", "");
        setValue("zipCode", "");
        if (watch("country") !== "US" && watch("country") !== "CA") {
            setValue("state", "");
        } else {
            setValue("state", "---");
        }
    };

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit, watch, clearErrors, setValue } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;

    const showEditForm = () => {
        setCountry();
        setShowEdit(true);
    };

    const hideEditForm = () => {
        setValue("country", accountInfo ? accountInfo.country : "US");
        countryChangeDetected();
        setShowEdit(false);
    };

    const save = (accountInformation: any) => {
        setCountry();
        if (accountInformation && !accountInformation.country) {
            accountInformation.country = "US";
        }
        if ((accountInformation && accountInformation.country !== "US") || accountInformation.country !== "CA") {
            accountInformation.state = accountInformation.state.toUpperCase().substring(0, 50);
        }
        if (accountInformation && contactPreference && personalAccountInformation && businessInformation) {
            setisLoading(true);
            services.GetAccountInformation().then((accountInfoResponse) => {
                const requestBody = {
                    FirstName: personalAccountInformation.firstName,
                    LastName: personalAccountInformation.lastName,
                    MiddleName: personalAccountInformation.middleInitial,
                    Email: personalAccountInformation.primaryEmail,
                    Phone: personalAccountInformation.primaryPhone,
                    PersonalSMS: contactPreference.smsNumber
                        ? getCountryInfo()
                            ? contactPreference.smsNumber.replace(/[^0-9+]/g, "")
                            : contactPreference.smsNumber
                        : contactPreference.smsNumber,
                    IsEmailIdentityNotificationOptOut: contactPreference.idCrimeAndBreachNews,
                    IsEmailNotificationOptOut: contactPreference.alertNotification,
                    IsPushNotificationOptOut: contactPreference.appPushNotification,
                    IsSmsNotificationOptOut: contactPreference.textSMSNotification,

                    Address1: accountInformation.address1,
                    Address2: accountInformation.address2,
                    City: accountInformation.city,
                    State: accountInformation.state,
                    Country: accountInformation.country,
                    ZipCode: accountInformation.zipCode,
                    BusinessName: businessInformation.businessName,
                    EIN: accountInfoResponse._unifiedAccountInfo._businessInformation.ein,
                    FAX: businessInformation.fax,
                    UserName: accountInformation.userName,
                };
                httpClient
                    .sendRequest("POST", "api/accountInfo/saveContactInformation", requestBody)
                    .then((data) => {
                        setisLoading(false);
                        if (data.isSuccess) {
                            Notification({
                                type: "success",
                                title: tLang("manageAccount.myAccount.companyAddress.notification.successTitle"),
                                message: tLang("manageAccount.myAccount.companyAddress.notification.successMsg"),
                            });
                            getAccountInformation(true);
                            setShowEdit(false);
                        }
                    })
                    .catch(function (error) {
                        setisLoading(false);
                        Notification({
                            type: "error",
                            title: tLang("manageAccount.myAccount.companyAddress.notification.errorTitle"),
                            message: error,
                            duration: 0,
                        });
                    });
            });
        }
    };

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";
        let country = watch("country") ? watch("country") : "";

        if ((currentCountry.includes("US") || currentCountry.includes("CA")) && !country) {
            return false;
        } else if (country.includes("US") || country.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <RenderIcons iconName="map-marker" />
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">{tLang("manageAccount.myAccount.companyAddress.title")}</h2>
                        </div>
                    </div>
                    {!showEdit && (
                        <div className="box-actions">
                            <button type="button" className="btn-default btn-grey-dot" id="company-address-info" onClick={() => showEditForm()}>
                                <span className="btn-text">
                                    {tLang("manageAccount.myAccount.membershipInformation.editButtonText")}{" "}
                                    <span className="sr-only">{tLang("manageAccount.myAccount.companyAddress.title")}</span>
                                </span>
                                <span className="btn-icon">
                                    <RenderIcons iconName="pen" />
                                </span>
                            </button>
                        </div>
                    )}
                </div>

                <div className={isLoading ? "box-content loading" : "box-content"}>
                    {/* Grid Content */}
                    {!showEdit && accountInfo && personalAccountInformation && (
                        <div role="grid" className="data-grid " id="country-address-info-grid" aria-hidden="false">
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-street-display">
                                        {tLang("manageAccount.myAccount.companyAddress.label.street")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-street-display">
                                    <div className="data-value">
                                        <span>{accountInfo.address1}</span>
                                        {accountInfo.address2 && accountInfo.address2.length > 0 && <p> {accountInfo.address2}</p>}
                                    </div>
                                </div>
                            </div>
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-city-display">
                                        {tLang("manageAccount.myAccount.companyAddress.label.city")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-city-display">
                                    <div className="data-value">
                                        {accountInfo.city}
                                    </div>
                                </div>
                            </div>
                            {accountInfo && (accountInfo.country === "US" || accountInfo.country === "") ? (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-state-display">
                                            {tLang("manageAccount.myAccount.companyAddress.label.state")}
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-state-display">
                                        <div className="data-value">
                                            {stateList.find((s) => s.value === accountInfo.state)?.name}
                                        </div>
                                    </div>
                                </div>
                            ) : accountInfo && accountInfo.country === "CA" ? (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-state-display">
                                            {tLang("manageAccount.myAccount.companyAddress.label.province")}
                                        </div>
                                    </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-state-display">
                                        <div className="data-value">
                                            {CAProvinces.find((s) => s.value === accountInfo.state)?.name}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-state-display">
                                            {tLang("manageAccount.myAccount.companyAddress.label.region")}
                                        </div>
                                    </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-state-display">
                                        <div className="data-value">
                                            {accountInfo.state}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-state-country">
                                        {tLang("manageAccount.myAccount.companyAddress.label.country")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-state-country">
                                    {supportInternational ? (
                                        <div className="data-value">
                                            {getCountries.countryList.length &&
                                                getCountries.countryList.find((s: any) => s.countryCode === accountInfo.country)?.name}
                                        </div>
                                    ) : (
                                        <div className="data-value">
                                            United States
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-zip-display">
                                        {zipCode.Label === "Zip Code"
                                            ? tLang("manageAccount.myAccount.companyAddress.label.zipcode")
                                            : tLang("manageAccount.myAccount.companyAddress.label.postalCode")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-zip-display">
                                    <div className="data-value">
                                        {accountInfo.zipCode}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Form Content */}

                    {showEdit && personalAccountInformation && accountInfo && (
                        <div id="my-account-info-form">
                            <form id="country-address-info-form-container" onSubmit={handleSubmit(save)}>
                                <div className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label" ><label htmlFor="label-address1">
                                                {tLang("manageAccount.myAccount.companyAddress.label.street")}{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                            </span>
                                            </label>
                                            </legend>
                                        </div>

                                        <div role="alert" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["address1"] ? "form-row row status-error" : "form-row row"}>
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-address-1">
                                                                    Address Line 1{" "}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-address1"
                                                                    name="address1"
                                                                    placeholder={tLang("manageAccount.myAccount.companyAddress.placeholder.addressLine1")}
                                                                    defaultValue={accountInfo.address1}
                                                                    maxLength={100}
                                                                    ref={register({ pattern: PATTERNS.STREETADDRESS.pattern, required: true })}
                                                                    aria-required="true"
                                                                />
                                                                {errors.address1 && errors.address1.type === "pattern" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.myAccount.companyAddress.validationMessage.address1.pattern")}
                                                                    </span>
                                                                )}
                                                                {errors.address1 && errors.address1.type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.myAccount.companyAddress.validationMessage.address1.required")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["address2"] ? "form-row row status-error" : "form-row row"}>
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-address2">Address Line 2</label>
                                                            </div>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-address2"
                                                                    name="address2"
                                                                    placeholder={tLang("manageAccount.myAccount.companyAddress.placeholder.addressLine2")}
                                                                    defaultValue={accountInfo.address2}
                                                                    maxLength={100}
                                                                    ref={register({
                                                                        pattern: PATTERNS.STREETADDRESS.pattern,
                                                                    })}
                                                                />
                                                                {errors.address2 && errors.address2.type === "pattern" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.myAccount.companyAddress.validationMessage.address2.pattern")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={errors["city"] ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-city">
                                                {tLang("manageAccount.myAccount.companyAddress.label.city")}{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            <input
                                                type="text"
                                                className="inputbox"
                                                id="label-city"
                                                placeholder={tLang("manageAccount.myAccount.companyAddress.placeholder.city")}
                                                name="city"
                                                defaultValue={accountInfo.city}
                                                ref={register({ required: true, pattern: PATTERNS.CITY.pattern })}
                                                maxLength={20}
                                                aria-required="true"
                                            />
                                            {errors.city && errors.city.type === "required" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.myAccount.companyAddress.validationMessage.city.required")}
                                                </span>
                                            )}
                                            {errors.city && errors.city.type === "pattern" && (
                                                <span className="form-error">{tLang("manageAccount.myAccount.companyAddress.validationMessage.city.pattern")}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={errors["state"] ? "form-row row status-error" : "form-row row"} role="alert">
                                    {watch("country") === "US" || !supportInternational || (!watch("country") && accountInfo && accountInfo.country === "US") ? (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-state">
                                                    {tLang("manageAccount.myAccount.companyAddress.label.state")}{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <select
                                                    className="inputbox"
                                                    id="label-state"
                                                    defaultValue={accountInfo.state}
                                                    name="state"
                                                    ref={register({ required: true, validate: (value) => value !== "---" })}
                                                    aria-required="true"
                                                >
                                                    {stateList.map((val: any) => (
                                                        <option key={val.name} value={val.value}>
                                                            {val.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors["state"] && errors["state"].type === "validate" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.myAccount.companyAddress.validationMessage.state.required")}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ) : watch("country") === "CA" || (!watch("country") && accountInfo && accountInfo.country === "CA") ? (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-state">
                                                    {tLang("manageAccount.myAccount.companyAddress.label.province")}{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <select
                                                    className="inputbox"
                                                    id="label-state"
                                                    defaultValue={accountInfo.state}
                                                    name="state"
                                                    ref={register({ required: true, validate: (value) => value !== "---" })}
                                                    aria-required="true"
                                                >
                                                    {CAProvinces.map((val: any) => (
                                                        <option key={val.name} value={val.value}>
                                                            {val.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors["state"] && errors["state"].type === "validate" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.myAccount.companyAddress.validationMessage.province.required")}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-state">
                                                    {tLang("manageAccount.myAccount.companyAddress.label.region")}{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <input
                                                    type="text"
                                                    name="state"
                                                    defaultValue={accountInfo.state}
                                                    ref={register({ required: true, pattern: PATTERNS.REGION.pattern })}
                                                    className="inputbox"
                                                    id="label-state"
                                                    placeholder={tLang("manageAccount.myAccount.companyAddress.placeholder.region")}
                                                    aria-required="true"
                                                />
                                                {errors["state"] && errors["state"].type === "required" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.myAccount.companyAddress.validationMessage.region.required")}
                                                    </span>
                                                )}
                                                {errors["state"] && errors["state"].type === "pattern" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.myAccount.companyAddress.validationMessage.region.pattern")}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className={errors["country"] ? "form-row row status-error" : "form-row row"} role="alert">
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-country">
                                                {tLang("manageAccount.myAccount.companyAddress.label.country")}{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            {supportInternational ? (
                                                <select
                                                    className="inputbox"
                                                    id="label-country"
                                                    defaultValue={accountInfo.country}
                                                    name="country"
                                                    onChange={() => {
                                                        countryChangeDetected();
                                                        clearErrors(["primaryPhone"]);
                                                    }}
                                                    ref={register({ required: true, validate: (value) => value !== "" })}
                                                    aria-required="true"
                                                >
                                                    {getCountries.countryList.length &&
                                                        getCountries.countryList.map((val: any) => (
                                                            <option key={val.name} value={val.countryCode}>
                                                                {val.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            ) : (
                                                <input type="text" name="country" className="inputbox" value="United States" id="label-country" aria-required="true" disabled />
                                            )}
                                            {errors["country"] && errors["country"].type === "validate" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.myAccount.companyAddress.validationMessage.country.required")}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className={errors["zipCode"] ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-zipCode">
                                                {zipCode.Label === "Zip Code"
                                                    ? tLang("manageAccount.myAccount.companyAddress.label.zipcode")
                                                    : tLang("manageAccount.myAccount.companyAddress.label.postalCode")}{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            <input
                                                type="text"
                                                className="inputbox"
                                                id="label-zipCode"
                                                placeholder={
                                                    zipCode.Label === "Zip Code"
                                                        ? tLang("manageAccount.myAccount.companyAddress.placeholder.zipcode")
                                                        : tLang("manageAccount.myAccount.companyAddress.placeholder.postalCode")
                                                }
                                                name="zipCode"
                                                defaultValue={accountInfo.zipCode}
                                                ref={register({ required: true, pattern: PATTERNS[zipCode.Pattern].pattern })}
                                                maxLength={zipCode.MaxLength}
                                                aria-required="true"
                                            />
                                            {errors.zipCode && errors.zipCode.type === "required" && (
                                                <span className="form-error">
                                                    {" "}
                                                    {zipCode.Label === "Zip Code"
                                                        ? tLang("manageAccount.myAccount.companyAddress.validationMessage.zipCode.required")
                                                        : tLang("manageAccount.myAccount.companyAddress.validationMessage.postalCode.required")}
                                                </span>
                                            )}
                                            {errors.zipCode && errors.zipCode.type === "pattern" && (
                                                <span className="form-error">
                                                    {" "}
                                                    {zipCode.Label === "Zip Code"
                                                        ? tLang("manageAccount.myAccount.companyAddress.validationMessage.zipCode.pattern")
                                                        : tLang("manageAccount.myAccount.companyAddress.validationMessage.postalCode.pattern")}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="margin-vertical-l"></div>

                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                                    onClick={() => hideEditForm()}
                                                >
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.membershipInformation.cancelButtonText")}</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button type="submit" className="btn-default btn-primary btn-min-width" disabled={isSubmitting}>
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.membershipInformation.saveButtonText")}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default CompanyAddress;
